import { create } from 'zustand';

interface ActivityFeedStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useActivityFeedStore = create<ActivityFeedStore>(set => ({
  open: false,
  setOpen: open => set({ open }),
}));
